import { createStore } from "vuex";
import CookieToastStore from "@Scripts/Stores/CookieToastStore";

export const store = createStore({
    modules: {
        "cookieToastStore": CookieToastStore
    }
});